var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtc2Perp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    fill: "none",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.726 -22.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m261.68 144.73c-1.14 65.651-55.263 118.07-121.03 116.95-65.661-1.187-118.02-55.325-116.88-120.98 1.1403-65.65 55.226-118.06 120.84-116.91 65.76 0.9249 118.17 55.252 117.07 120.93z",
    fill: "#f7931a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.05 123.01c-1.377-14.749-13.954-19.711-29.998-21.325l0.153-20.42-12.418-0.1242-0.111 19.967c-3.285-0.017-6.606-0.026-9.867 0.062l0.11-19.967-12.559-0.0919-0.153 20.42c-2.658-0.014-5.319 0.12-7.977 0.106l-17.108-0.149-0.0861 13.203s9.2324-0.1 8.9578 0.148c5.0363 0.093 6.667 3.003 7.042 5.428l-0.125 23.257c0.348 0.067 0.768-0.03 1.296 0.181-0.488-0.036-0.768 0.029-1.255-6e-3l-0.019 32.502c-0.255 1.61-1.2749 4.061-4.7007 4.076 0.1724 0.108-9.1327-0.107-9.1327-0.107l-2.4339 14.853 16.159 0.036c3.006 0.082 5.979 0.023 8.818 0.18l-0.113 20.596 12.419 0.124 0.153-20.42c3.493 0.117 6.787 0.169 9.932 0.218l-0.185 20.28 12.419 0.124 0.112-20.595c20.921-1.064 35.559-6.179 37.417-25.922 1.526-15.751-5.757-22.859-17.74-25.89 7.429-3.599 11.927-9.992 10.993-20.744zm-17.7 44.08c-0.056 15.413-26.493 13.503-34.851 13.401l0.102-27.351c8.505 0.104 34.782-2.195 34.749 13.95zm-5.511-38.721c-0.056 13.972-22.079 12.335-29.146 12.231l0.24-24.835c6.919 0.102 29-2.005 28.906 12.604z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.93 133v-7.161c3.286-2.721 6.468-5.416 9.548-8.085 3.132-2.669 5.904-5.313 8.316-7.931 2.464-2.618 4.415-5.159 5.852-7.623 1.489-2.5153 2.233-4.9537 2.233-7.315 0-2.2073-0.616-4.158-1.848-5.852-1.18-1.694-3.157-2.541-5.929-2.541-2.823 0-4.953 0.924-6.391 2.772-1.437 1.848-2.156 4.081-2.156 6.699h-9.548c0.103-3.9527 0.976-7.238 2.618-9.856 1.643-2.6693 3.825-4.6457 6.545-5.929 2.721-1.3347 5.775-2.002 9.163-2.002 5.493 0 9.754 1.5143 12.782 4.543 3.08 2.9773 4.62 6.853 4.62 11.627 0 2.9773-0.693 5.878-2.079 8.701-1.334 2.823-3.105 5.544-5.313 8.162-2.207 2.618-4.594 5.082-7.161 7.392-2.566 2.259-5.056 4.363-7.469 6.314h23.331v8.085z",
    fill: "url(#paint0_radial_3517_14106)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3517_14106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(41.631 0 0 65.117 180 107)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40045A",
    offset: 0.038622
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A21E7C",
    offset: 0.67708
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc2Perp);
export default __webpack_public_path__ + "static/media/btc^2-perp.f080b0663f1ea650f8705154400716a0.svg";
export { ForwardRef as ReactComponent };